export default {
  sales: [],
  contact: {},
  loading: false
}



// WEBPACK FOOTER //
// ./src/reports-aggrid/modules/sales-budget-detail/state.js